/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Assets */
import Space from '../../assets/svg/back.svg';

/* Styles */
import './Hint.scss';

const ICONS = {
  back: Space,
};

function Hint({ title, icon = undefined }) {
  return (
    <>
      <p className="dtv-html5-c-hint__title">
        <FormattedMessage id={title} />
      </p>
      {icon && (
        <img
          className="dtv-html5-c-hint__icon"
          src={ICONS[icon]}
          alt="hint-icon"
        />
      )}
    </>
  );
}

Hint.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOf(Object.keys(ICONS)),
};

export default memo(Hint);
